import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c96a906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-warp" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"desc-text absolute\" data-v-2c96a906><div class=\"title-cn f-s-42 f-w-500 col-b-white m-b-6\" data-v-2c96a906>企业简介</div><div class=\"title-en f-s-26 f-w-500 m-b-18\" style=\"color:rgba(255, 255, 255, 0.7);\" data-v-2c96a906>COMPANY PROFILE </div><div class=\"description\" data-v-2c96a906>武汉东信同邦信息技术有限公司 ( 简称：ETAH ) 成立于2007年，总部坐落于中国 · 光谷， 是一家拥有多项高度自主核心知识产权的高新技术企业。2022年获评专精特新“小巨人”企业， 这标志着东信同邦在教育信息化领域发挥了良好的示范引领作用，是专注于细分市场、创新能力强、市场占有率高、掌握关键核心技术、 质量效益优的“排头兵”企业。 </div><div class=\"description\" data-v-2c96a906> 深耕教育行业多年，东信同邦一直致力于教育信息化产品的研发、生产、推广与应用，为国内外大、中小学提供全面优质的信息化方案及服务。 现在，东信同邦研发人员占比超过总人数50%，在嵌入式技术、3D传感、高清音视频压缩编码、多媒体网络传输、H.323/SIP 协议研发、 大并发流媒体服务器、音频信号处理、云平台、人工智能等方面具备快速响应的研发实力。 </div><div class=\"description\" data-v-2c96a906> 凭借对教育的深刻理解，依托IT技术的深厚积累，东信同邦持续开创业界创新应用的先河。近年来，东信同邦专注智慧教学应用，率先推出 高度融合、高度易用、高度稳定的“智慧教室终端”，实现1块屏幕+1台核心设备建设1间智慧教室，开创智慧教室常态化应用新篇章。 多目ai摄像机、智慧教学音箱、3D传感器等产品，将人工智能技术与教学场景深度融合，东信同邦一直在创新中引领前行。 </div><div class=\"description\" data-v-2c96a906> 东信同邦已经建立起以武汉为中心、覆盖全国的本地化服务中心，业务延伸至10余个国家与地区。未来，东信同邦将继续始终如一地为客户提 供快速高品质的服务，为合作伙伴提供优质高效率的支持。 </div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "slogan" }
const _hoisted_5 = { class: "slogan-wrap flex align-center justify-around" }
const _hoisted_6 = {
  class: "f-s-32 f-w-500 col-b-white",
  style: {"width":"308px","text-align":"center"}
}
const _hoisted_7 = {
  class: "f-s-22 f-w-400 m-t-23",
  style: {"color":"rgba(255, 255, 255, 0.7)"}
}
const _hoisted_8 = { class: "team-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-w-600 f-s-42 flex justify-center col-b-title h-59 l-h-59 p-t-80 p-b-70" }, "我们的团队", -1))
const _hoisted_10 = {
  key: 0,
  class: "cardinal common-item"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "team-text" }
const _hoisted_13 = { class: "team-index" }
const _hoisted_14 = { class: "team-name" }
const _hoisted_15 = { class: "team-slogan" }
const _hoisted_16 = { class: "team-description" }
const _hoisted_17 = { class: "description wbba" }
const _hoisted_18 = {
  key: 1,
  class: "even common-item"
}
const _hoisted_19 = { class: "team-text" }
const _hoisted_20 = { class: "team-index" }
const _hoisted_21 = { class: "team-name" }
const _hoisted_22 = { class: "team-slogan" }
const _hoisted_23 = { class: "team-description" }
const _hoisted_24 = { class: "description wbba" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "event-wrap" }
const _hoisted_27 = { style: {"width":"1200px","margin":"0 auto","height":"100%"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "f-s-42 f-w-600 col-b-title text-center p-t-80 p-b-70",
  style: {"height":"59px","line-height":"59px"}
}, " 大事记 ", -1))
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "swiper" }
const _hoisted_31 = { class: "swiper-wrapper" }
const _hoisted_32 = { class: "event-detail" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "event-text" }
const _hoisted_35 = { class: "f-s-32 f-w-500 h-45 l-h-45 col-b-title m-b-8" }
const _hoisted_36 = { class: "f-s-16 f-w-400 l-h-26 col-b-content wbba" }
const _hoisted_37 = { class: "time-line" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "identify-wrap bg-b-white" }
const _hoisted_40 = { style: {"width":"1200px","margin":"0 auto"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-s-42 col-b-title f-w-500 h-59 l-h-59 p-t-80 p-b-70 text-center" }, "企业资质", -1))
const _hoisted_42 = { style: {"height":"432px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "desc-wrap relative",
      style: _normalizeStyle({background: "url("+_ctx.companyBgUrl+")", backgroundSize: "cover",
		backgroundPosition: "center"})
    }, _hoisted_3, 4),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sloganList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "slogan-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.desc), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "team-item",
          key: index
        }, [
          ((index+1) % 2 !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  class: "team-img",
                  src: item.image
                }, null, 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(index < 10 ? '0' + (index + 1) : index + 1), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.subtitle), 1),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([item.section_one, item.section_two], (desc) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(desc), 1))
                    }), 256))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(index < 10 ? '0' + (index + 1) : index + 1), 1),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(item.subtitle), 1),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([item.section_one, item.section_two], (desc) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(desc), 1))
                    }), 256))
                  ])
                ]),
                _createElementVNode("img", {
                  class: "team-img",
                  src: item.image
                }, null, 8, _hoisted_25)
              ]))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "swiper-slide",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("img", {
                      src: item.image
                    }, null, 8, _hoisted_33),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(item.year), 1),
                      _createElementVNode("div", _hoisted_36, _toDisplayString(item.desc), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", {
              class: "line",
              style: _normalizeStyle({left: _ctx.linePosObj.start+"px",
						width: (_ctx.linePosObj.end - _ctx.linePosObj.start)+"px"})
            }, null, 4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventListWithPosition, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["year-item pointer", {["active-item"] : _ctx.currentYear === item.year}]),
                key: item.year,
                style: _normalizeStyle({left:item.pos + "px"}),
                onClick: ($event: any) => (_ctx.handleClickYearItem(item))
              }, _toDisplayString(item.year), 15, _hoisted_38))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", {
            style: _normalizeStyle({background: "url("+_ctx.identifyUrl+")", backgroundSize: "cover",
		backgroundPosition: "center", height: "414px"})
          }, null, 4)
        ])
      ])
    ])
  ]))
}